import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IDomain } from '@amt/i-domain';

import { IEmailTemplate } from '@amt/i-email-template';
import { IOrganization } from '@amt/i-organization';

import {
    Blocker,
    LoadBlockerService,
} from 'bkng';

import { EnvService } from '@s/env.service';
import { IAddDomainDialogData } from '../add-domain-dialog/add-domain-dialog.component';

import { OrganizationService } from '@s/organization.service';
import { IEnv } from '@alt/i-env';
import { DomainPostResult } from '@api-routes/domain/types/domain-post-result';

@Component({
    selector: 'app-organization-domains-view',
    templateUrl: './organization-domains-view.component.html',
    styleUrls: ['./organization-domains-view.component.scss']
})
export class OrganizationDomainsViewComponent implements OnInit {
    blocker: Blocker;
    domains: Array<IDomain>;
    emailTemplates: Array<IEmailTemplate> = [];
    env: IEnv;
    organization: IOrganization;
    data: IAddDomainDialogData;

    constructor (
        public envService: EnvService,
        public lbs: LoadBlockerService,
        public organizationService: OrganizationService,
        public route: ActivatedRoute,
    ) {
        this.env = envService.data;
        this.blocker = lbs.register({});

        this.fetch().catch(console.error).finally(() => {
            this.blocker.unblock();
        });
    }

    async createdDomain (data: DomainPostResult): Promise<void> {
        await this.fetch();
    }

    fetch (): Promise<void> {
        return this.organizationService.getById({
            organizationId: <string>(this.route.snapshot.params.organizationId),
        }).then((res) => {
            console.log("OrganizationDomainsViewComponent", res);
            Object.assign(this, res);
            this.data = res;
            return Promise.resolve();
        });
    }

    ngOnInit (): void {
    }
}
